var installedModules = {};
var moduleToHandlerMapping = {
	82344: {
		getter: ()=>()=>{throw new Error("Can not get '@angular/core'")},
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	90114: {
		getter: ()=>()=>{throw new Error("Can not get '@angular/common'")},
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	94172: {
		getter: () => (Promise.all([__webpack_require__.e(367), __webpack_require__.e(671), __webpack_require__.e(329)]).then(() => (() => (__webpack_require__(6329))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~7.8.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	84588: {
		getter: () => (Promise.all([__webpack_require__.e(367), __webpack_require__.e(671), __webpack_require__.e(439)]).then(() => (() => (__webpack_require__(93439))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~7.8.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs/operators",
	},
	65314: {
		getter: () => (Promise.all([__webpack_require__.e(981), __webpack_require__.e(809)]).then(() => (() => (__webpack_require__(68809))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~7.8.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs/operators",
	},
	40626: {
		getter: () => (Promise.all([__webpack_require__.e(981), __webpack_require__.e(323)]).then(() => (() => (__webpack_require__(16323))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~7.8.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	5896: {
		getter: () => (__webpack_require__.e(0).then(() => (() => (__webpack_require__(36000))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.3.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "tslib",
	},
	17367: {
		getter: () => (__webpack_require__.e(331).then(() => (() => (__webpack_require__(10331))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.3.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "tslib",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"114": [
		90114
	],
	"172": [
		94172
	],
	"177": [
		65314,
		40626
	],
	"344": [
		82344
	],
	"367": [
		17367
	],
	"588": [
		84588
	],
	"981": [
		5896
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}